import { NgModule } from '@angular/core';

import { AdminDashboardActionsComponent } from './admin-dashboard.actions.component';
import { SharedModule }                   from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    // Components
    AdminDashboardActionsComponent
  ],
  entryComponents: [
    AdminDashboardActionsComponent
  ],
  exports: [
    // Components
    AdminDashboardActionsComponent
  ],
  imports: [
    SharedModule
  ]
})
export class AdminDashboardModule {}